import { createFileRoute } from '@tanstack/react-router'
import { IntelligenceDirectory } from '@/components/directory/IntelligenceDirectory'

/**
 * New design: Data section (Intelligence Directory)
 */
export const Route = createFileRoute('/_app/data')({
  component: IntelligenceDirectory,
})
